import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useEffect, useRef, useState } from 'react';
import { SortOrder } from 'primereact/api';
import { useGlobalState } from '../../components/globalState/GlobalStateProvider';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Badge } from 'primereact/badge';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import findNotaFiscal from '../../service/findNotaFiscal';
import getNotaFiscalPdf from '../../service/getNotaFiscalPdf';
import getNotaFiscalXml from '../../service/getNotaFiscalXml';
import patchNotaFiscalCancelar from '../../service/patchNotaFiscalCancelar';

export default function NotaFiscalPage() {
  const { t } = useTranslation();
  const [notasFiscais, setNotasFiscais] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  const { state } = useGlobalState();
  const toast = useRef<Toast>(null);
  const [chave, setChave] = useState<string>('null');
  const [documento, setDocumento] = useState<string>('null');
  const [status, setStatus] = useState<string>('null');
  const [confirmCancelarVisible, setConfirmCancelarVisible] = useState(false);
  const [notaFiscalParaCancelar, setNotaFiscalParaCancelar] = useState<any>(null);

  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    chave: 'null',
    documento: 'null',
    status: 'null',
    sortField: 'dataInclusao',
    sortOrder: SortOrder.DESC
  });

  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: (event.first / event.rows) + 1,
      chave: chave || 'null',
      documento: documento || 'null',
      status: status || 'null',
      sortField: event.sortField || 'dataInclusao',
      sortOrder: event.sortOrder
    });
  };

  const onSort = (event: any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      chave: chave || 'null',
      documento: documento || 'null',
      status: status || 'null',
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const loadLazyData = () => {
    findNotaFiscal(lazyState)
      .then(data => {
        setTotalRecords(data.total);
        setNotasFiscais(data.notasFiscais);
      })
      .catch(() => {
        setTotalRecords(0);
        setNotasFiscais(undefined);
      });
  };

  const changeChave = (value: string) => {
    const val = value || 'null';
    setChave(val);
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      chave: val,
      documento: documento || 'null',
      status: status || 'null',
      sortField: 'dataInclusao',
      sortOrder: SortOrder.DESC
    });
  };

  const changeDocumento = (value: string) => {
    const val = value || 'null';
    setDocumento(val);
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      chave: chave || 'null',
      documento: val,
      status: status || 'null',
      sortField: 'dataInclusao',
      sortOrder: SortOrder.DESC
    });
  };

  const changeStatus = (value: string) => {
    const val = value || 'null';
    setStatus(val);
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      chave: chave || 'null',
      documento: documento || 'null',
      status: val,
      sortField: 'dataInclusao',
      sortOrder: SortOrder.DESC
    });
  };

  const clearFields = () => {
    setChave('null');
    setDocumento('null');
    setStatus('null');
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      chave: 'null',
      documento: 'null',
      status: 'null',
      sortField: 'dataInclusao',
      sortOrder: SortOrder.DESC
    });
  };

  const downloadPdf = (notaFiscal: any) => {
    getNotaFiscalPdf(notaFiscal.id).then((blobFile: Blob) => {
      const url = window.URL.createObjectURL(new Blob([blobFile], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `nota_fiscal_${notaFiscal.id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }).catch(() => {
      toast.current?.show({ severity: 'error', summary: 'Erro', detail: 'Erro ao baixar PDF', life: 4000 });
    });
  };

  const downloadXml = (notaFiscal: any) => {
    getNotaFiscalXml(notaFiscal.id).then((blobFile: Blob) => {
      const url = window.URL.createObjectURL(new Blob([blobFile], { type: 'application/xml' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `nota_fiscal_${notaFiscal.id}.xml`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }).catch(() => {
      toast.current?.show({ severity: 'error', summary: 'Erro', detail: 'Erro ao baixar XML', life: 4000 });
    });
  };

  const cancelarNotaFiscal = (notaFiscal: any) => {
    setNotaFiscalParaCancelar(notaFiscal);
    setConfirmCancelarVisible(true);
  };

  const confirmarCancelamento = () => {
    if (!notaFiscalParaCancelar) return;
    patchNotaFiscalCancelar(notaFiscalParaCancelar.id)
      .then(() => {
        toast.current?.show({ severity: 'success', summary: 'Sucesso', detail: 'Nota fiscal cancelada com sucesso', life: 4000 });
        setConfirmCancelarVisible(false);
        setNotaFiscalParaCancelar(null);
        loadLazyData();
      })
      .catch(() => {
        toast.current?.show({ severity: 'error', summary: 'Erro', detail: 'Erro ao cancelar nota fiscal', life: 4000 });
      });
  };

  const fecharConfirmCancelar = () => {
    setConfirmCancelarVisible(false);
    setNotaFiscalParaCancelar(null);
  };

  const formatDocumento = (doc: string): string => {
    if (!doc) return '';
    const digits = doc.replace(/\D/g, '');
    if (digits.length === 11) {
      return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    if (digits.length === 14) {
      return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    return doc;
  };

  const formatDataInclusao = (value: any): string => {
    if (!value) return '';
    const date = new Date(value);
    if (isNaN(date.getTime())) return value;
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };

  const statusTemplate = (notaFiscal: any) => {
    const statusClassMap: { [key: string]: string } = {
      'EMITIDA': 'status-badge-registrado',
      'CANCELADA': 'status-badge-excluido',
      'ERRO': 'status-badge-erro',
    };
    const statusClass = statusClassMap[notaFiscal.status] || 'status-badge-incluido';
    return <Badge value={notaFiscal.statusLabel || notaFiscal.status} className={statusClass} />;
  };

  const acoesTemplate = (notaFiscal: any) => {
    const emitida = notaFiscal.status === 'EMITIDA';
    const podeBaixar = state.user.funcoes.includes('NOTA_FISCAL_DOWNLOAD') && emitida;
    const podeCancelar = state.user.funcoes.includes('NOTA_FISCAL_CANCELAR') && emitida;
    if (!podeBaixar && !podeCancelar) {
      return null;
    }
    return (
      <>
        {podeBaixar && (
          <>
            <Button
              icon="pi pi-file-pdf"
              tooltip="Baixar PDF"
              tooltipOptions={{ position: 'top' }}
              onClick={() => downloadPdf(notaFiscal)}
              style={{ background: 'transparent', color: 'gray', border: 'none' }}
            />
            <Button
              icon="pi pi-file"
              tooltip="Baixar XML"
              tooltipOptions={{ position: 'top' }}
              onClick={() => downloadXml(notaFiscal)}
              style={{ background: 'transparent', color: 'gray', border: 'none' }}
            />
          </>
        )}
        {podeCancelar && (
          <Button
            icon="pi pi-ban"
            tooltip="Cancelar Nota Fiscal"
            tooltipOptions={{ position: 'top' }}
            onClick={() => cancelarNotaFiscal(notaFiscal)}
            style={{ background: 'transparent', color: 'gray', border: 'none' }}
          />
        )}
      </>
    );
  };

  const startContent = (
    <div className="filtros">
      <div className="filtros-grid">
        <div className="filtros-item">
          <label htmlFor="chave" className="font-bold">{t('chave')}</label>
          <InputText
            id="chave"
            value={chave === 'null' ? '' : chave}
            onChange={(e) => setChave(e.target.value || 'null')}
            onBlur={(e) => changeChave(e.target.value)}
            placeholder="Chave de Acesso"
          />
        </div>
        <div className="filtros-item">
          <label htmlFor="documento" className="font-bold">{t('documento')}</label>
          <InputText
            id="documento"
            value={documento === 'null' ? '' : documento}
            onChange={(e) => setDocumento(e.target.value || 'null')}
            onBlur={(e) => changeDocumento(e.target.value)}
            placeholder="Documento"
          />
        </div>
        <div className="filtros-item">
          <label htmlFor="status" className="font-bold">{t('status')}</label>
          <InputText
            id="status"
            value={status === 'null' ? '' : status}
            onChange={(e) => setStatus(e.target.value || 'null')}
            onBlur={(e) => changeStatus(e.target.value)}
            placeholder="Status"
          />
        </div>
      </div>
      <div className="filtros-acoes">
        <Button label='Limpar' icon="pi pi-times" onClick={clearFields} className="button_remove_backgroung" outlined style={{ color: '#183462' }} />
      </div>
    </div>
  );

  useEffect(() => {
    loadLazyData();
  }, [lazyState]);

  return (
    <Container>
      <Toast ref={toast} />
      <div className="row">
        <div className="col-lg-12 mb-3">
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h3 mb-0 text-gray">
              <i className="pi pi-file" style={{ fontSize: '2.0rem' }}></i> {t('notasFiscais')}
            </h1>
          </div>
        </div>
      </div>
      <div className="card">
        <Toolbar start={startContent} />
        <br />
        <DataTable
          value={notasFiscais}
          first={lazyState.first}
          dataKey="id"
          paginator={true}
          lazy={true}
          emptyMessage="Sem registros"
          onSort={onSort}
          sortField={lazyState.sortField}
          sortOrder={lazyState.sortOrder}
          rows={lazyState.rows}
          totalRecords={totalRecords}
          onPage={onPage}
          tableStyle={{ minWidth: '75rem' }}
        >
          <Column field="chave" sortable header={t('chave')} />
          <Column field="documento" sortable header={t('documento')} body={(row) => formatDocumento(row.documento)} />
          <Column field="valor" sortable header={t('valor')} />
          <Column field="origem" sortable header={t('origem')} />
          <Column field="dataInclusao" sortable header={t('dataInclusao')} body={(row) => formatDataInclusao(row.dataInclusao)} />
          <Column body={statusTemplate} header={t('status')} />
          <Column body={acoesTemplate} style={{ width: '8%' }} />
        </DataTable>
      </div>
      <Dialog
        visible={confirmCancelarVisible}
        header="Cancelar Nota Fiscal"
        modal
        style={{ width: '440px' }}
        onHide={fecharConfirmCancelar}
        footer={
          <React.Fragment>
            <Button label="Fechar" severity="secondary" outlined onClick={fecharConfirmCancelar} />
            <Button label="Confirmar" style={{ backgroundColor: '#183462' }} onClick={confirmarCancelamento} />
          </React.Fragment>
        }
      >
        <p style={{ marginBottom: '1rem' }}>Deseja cancelar a nota fiscal abaixo?</p>
        <div className="p-fluid">
          <div className="field">
            <label className="font-bold block mb-1">{t('dataInclusao')}</label>
            <InputText value={formatDataInclusao(notaFiscalParaCancelar?.dataInclusao)} readOnly />
          </div>
          <div className="field">
            <label className="font-bold block mb-1">{t('chave')}</label>
            <InputText value={notaFiscalParaCancelar?.chave || ''} readOnly />
          </div>
          <div className="field">
            <label className="font-bold block mb-1">{t('documento')}</label>
            <InputText value={notaFiscalParaCancelar?.documento || ''} readOnly />
          </div>
        </div>
      </Dialog>
    </Container>
  );
}
